import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import SearchBar from '../../molecules/SearchBar';
import Category from '../../molecules/Category';
import PageInfo from '../../molecules/PageInfo';
import List from '../../molecules/List';
import Gallery from '../../molecules/Gallery/Gallery';
import Collapse from '../../molecules/Collapse';
import Pagination from '../../molecules/Pagination';

function BoardView(props) {
  const { boardInfo, paging } = props;

  /**
   * 게시판 유형에 맞는 형태의 목록을 리턴
   * @param {string} type 게시판 유형
   * @returns
   */
  const handleSetListType = type => {
    if (type === 'BBST01') return <List {...props} />; // 일반
    if (type === 'BBST02') return <Gallery {...props} />; // Gallery 형태
    if (type === 'BBST04') return <Collapse {...props} />; // 펼치지는 형태
    if (type === 'BBST05') return <Gallery {...props} />; // 물건공고? 형태
  };

  return (
    <StyledSubContainer
      title="Support"
      // subTxt=""
      className="sub-support"
    >
      <div className="inner-container__sub">
        <SearchBar {...props} />
        {/* S::기본 테이블형 게시판 - 리스트 */}
        <article className="c-bbs">
          <div className="c-bbs__header">
            <Category {...props} />
            <PageInfo {...props} />
          </div>
          {handleSetListType(boardInfo?.bbsTyCode ?? 'BBST01')}
          <Pagination {...paging} />
        </article>
        {/* E::기본 테이블형 게시판 - 리스트 */}
      </div>
    </StyledSubContainer>
  );
}

const StyledSubContainer = styled.div`
  h3 {
    text-align: center;
  }
  .c-bbs {
    margin-top: 12rem;
    &__header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 2.4rem;
      .title {
        word-break: break-all;
      }
    }
    /* 탭(카테고리&말머리) */
    &__tab {
      order: 2;
      /* margin-bottom: 4rem; */
      .tab {
        &__list {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          li {
            &.active {
              a {
                color: var(--color-white);
                border-color: var(--color-main);
                background-color: var(--color-main);
              }
            }
            a {
              display: block;
              padding: 1rem 2rem;
              color: var(--color-black);
              /* font-size: 1.6rem; */
              border: 1px solid var(--color-gray-d9d9d9);
            }
          }
        }
      }
    }
    &__total {
      font-size: 1.7rem;
      em {
        color: var(--color-main);
        font-weight: 500;
      }
    }
    /* 기본 테이블형 게시판 */
  }
  @media ${({ theme }) => theme.media.lgMin} {
    .c-bbs {
      /* 기본 테이블형 게시판 */
      &-board {
        /* 기본 테이블형 게시판 : 리스트 */
        &__list {
          li {
            > div {
              &.num {
                flex: 0 1 12rem;
              }
              &.title {
                flex: 1;
                min-width: 1%;
              }
              &.writer {
                flex: 0 1 16rem;
              }
              &.date {
                flex: 0 1 12rem;
              }
              &.hit {
                flex: 0 1 12rem;
              }
            }
            &:not(.list-head) {
              > div {
                &.title {
                  a {
                    max-width: calc(100% - 18rem);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media ${({ theme }) => theme.media.mdMinlg} {
    .c-bbs {
      /* 기본 테이블형 게시판 */
      &-board {
        /* 기본 테이블형 게시판 : 리스트 */
        &__list {
          li {
            > div {
              &.num {
                flex: 0 1 8rem;
              }
              &.title {
                flex: 1;
                min-width: 1%;
              }
              &.writer {
                flex: 0 1 12rem;
              }
              &.date {
                flex: 0 1 10rem;
              }
              &.hit {
                flex: 0 1 8rem;
              }
            }
            &:not(.list-head) {
              > div {
                &.title {
                  a {
                    max-width: calc(100% - 12rem);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media ${({ theme }) => theme.media.mdMin} {
    .c-bbs {
      margin-top: 12rem;
      /* 기본 테이블형 게시판 */
      &-board {
        /* 기본 테이블형 게시판 : 리스트 */
        &__list {
          li {
            display: flex;
            align-items: center;
            &.empty {
              flex-direction: column;
              justify-content: center;
            }
            &:not(.list-head):not(.empty) {
              > div {
                padding: 1.2rem 0.5rem;
              }
            }
          }
        }
      }
    }
  }
  @media ${({ theme }) => theme.media.md} {
    .c-bbs {
      margin-top: 6rem;
      &-board {
        /* 기본 테이블형 게시판 : 리스트 */
        &__list {
          li {
            display: block;
            > div {
              &.num {
                display: none;
              }
              &.title {
                display: block;
              }
              &.writer,
              &.date,
              &.hit {
                display: inline-block;
              }
              &.date,
              &.hit {
                position: relative;
                margin-left: 1rem;
                padding-left: 1rem;
                &::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 1px;
                  height: 14px;
                  border-left: 1px solid var(--color-gray-d9d9d9);
                }
              }
            }
            &.empty {
              text-align: center;
            }
            &.list-head {
              display: none;
            }
            &:not(.list-head) {
              padding: 1.2rem 0.5rem;
              > div {
                &.title {
                  a {
                    max-width: calc(100% - 12rem);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

BoardView.propTypes = {
  boardInfo: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  paging: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  notiList: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
  ),
  dataList: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
  ),
  searchOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  categoryOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  onCategory: PropTypes.func,
  onSearch: PropTypes.func,
  onMoveNotiDetail: PropTypes.func,
  onMoveDetail: PropTypes.func,
};

BoardView.defaultProps = {
  boardInfo: {},
  paging: {},
  notiList: [],
  dataList: [],
  searchOption: {},
  categoryOption: {},
  onCategory: () => {},
  onSearch: () => {},
  onMoveNotiDetail: () => {},
  onMoveDetail: () => {},
};

export default BoardView;
